
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import { formatThousands } from '@/utils'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import {
  formatBanendFlag, formatDraftType, formatRequestEntrustPay, formatSplitFlag
} from '@/utils/acceptanceBillFormatUtil'
import Container from '@/components/form/container/Container.vue'
import { ElMessage } from 'element-plus'
import { getAvailableAcceptanceDetails } from '@/apis/accepted-bill/availableAcceptance'
import { AvailableAcceptanceModel } from '@/model/accepted-bill/availableAcceptanceModel'

export default defineComponent({
  name: 'AvailableAcceptanceDetail',
  methods: { formatThousands },
  components: {
    Container
  },
  setup() {
    const { t } = useI18n()
    const tableRef = ref()
    const id = useRoute().params.id.toString()
    const dataMap = reactive({
      detailData: {} as AvailableAcceptanceModel | null,
      async getData() {
        let acceptanceId
        try {
          acceptanceId = Number(id)
        } catch (error) {
          ElMessage({
            message: 'id 格式错误;' + id,
            type: 'error',
            duration: 2000
          })
          return
        }
        const data = await getAvailableAcceptanceDetails(acceptanceId)
        if (data && data.data) {
          dataMap.detailData = data.data
        } else {
          dataMap.detailData = null
          ElMessage({
            message: data?.msg,
            type: 'error',
            duration: 2000
          })
        }
      }
    })
    onMounted(() => {
      dataMap.getData()
    })
    return {
      t,
      tableRef,
      formatBanendFlag,
      formatSplitFlag,
      formatRequestEntrustPay,
      formatDraftType,
      ...toRefs(dataMap)
    }
  }
})
